import React, { useEffect, useState } from "react";
import { MDBAlert, MDBRadio, MDBCheckbox, MDBInputGroup, MDBTimepicker, MDBTooltip, MDBModal, MDBModalDialog, MDBModalContent, MDBModalHeader, MDBModalTitle, MDBBtn, MDBModalBody, MDBIcon, MDBInput } from 'mdb-react-ui-kit';
import DatePicker from "react-datepicker";
import { browserName, browserVersion } from "react-device-detect";
import {
  checkMembers,
  getStaffInfo,
  getPlanProfile, logEvent, memberActiveTransactions, membersessions, resumeMemberShip,
  getPlans,
  getBookedsessionsbymid,
  gustPassReferalCheck,
  getMemberlatestCheckin
} from "../services/apiServices.js";

import PageError from "../views/PageError.js";
import AddUsers from "../views/AddUsers.js";
import { BasePlanName } from "../utils/BasePlanName.js";
import { useAnalytics } from "../hooks/useAnalytics.js";
import GuestPassMembers from "./GuestPassMembers.js";

export default function LogATime(props) {

  const [trainer, setTrainer] = useState("");
  const [trainerid, settrainerid] = useState();
  const [Check, setCheck] = useState(false);
  const [userdata, setUserData] = useState("");
  const [auto, setAuto] = useState("")
  const [apiError, setApiError] = useState(false);
  const now = new Date();
  const [TrainerForce, setTrainerForce] = useState(false);
  const [basicDanger, setBasicDanger] = useState(false);
  const [Error2, setError2] = useState("");
  const currentHour = now.getHours();
  let hourValue = currentHour > 12 ? currentHour - 12 : currentHour;
  const currentMinute = now.getMinutes();
  console.log(currentHour + "" + currentMinute);
  const ttimeh = (currentHour + 2) % 12 || 12;
  const ttimem = (currentMinute) % 60;
  const fday2 = (currentHour + 2) >= 12 ? 'PM' : 'AM';
  const [Errorr, setErrorr] = useState({
    trainer: "",
    fromTime: "",
    toTime: "",
  })
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const [actTransactions, setActTransactions] = useState([])
  console.log("actTransactions", actTransactions)
  const [selectedplan, setSelectedplan] = useState(null)
  console.log("selectedplan", selectedplan)
  const [sessionData, setSessionData] = useState([])
  const [sessionvalue, setSessionvalue] = useState(null);
  const [openAddMember, setOpenAddMember] = useState(false);
  const [sharedSessionMember, setSharedSessionMember] = useState([]);
  const [checkinOption, setCheckinOption] = useState("withYou");
  const [cpCheck, setCpCheck] = useState(false)
  const [form, setForm] = useState({
    date: new Date(),
    ftimeh: hourValue.toString().padStart(2, '0'),
    ftimem: currentMinute.toString().padStart(2, '0'),
    fday1: currentHour >= 12 ? 'PM' : 'AM',
    ttimeh: ttimeh.toString().padStart(2, '0'),
    ttimem: ttimem.toString().padStart(2, '0'),
    autocheck: 0,
    fday2: fday2,
  });
  const [curIndex, setCurIndex] = useState(0);
  const [submitFlag, setSubmitFlag] = useState(false);
  const [activeClasses, setActiveClasses] = useState([])
  const [activeClass, setActiveClass] = useState(false);
  const [plans, setPlans] = useState("");
  const { trackButtonClick } = useAnalytics();

  const [isGuestMode, setIsGuestMode] = useState(false);
  const [multiGymPlanError, setMultiGymPlanError] = useState("");

  const [guestPassMembers, setGuestPassMembers] = useState([]);

  const [gustPassErrorMsg, setgustPassErrorMsg] = useState("")



  function retrunFromThis() {
    props.oncancel();
  }

  function updateForm(value) {
    return setForm((prev) => {
      return { ...prev, ...value };
    });
  }

  async function fetchData() {
    if (localStorage.getItem("loggedUserInfo")) {
      const response = await getStaffInfo(
        JSON.parse(localStorage.getItem("loggedUserInfo")).gymid
      );
      if (!response) {
        return;
      }
      if (response === "false") {
        setApiError(true)
        return;
      }
      const usersData = await response.json();
      console.log(usersData);

      setUserData(usersData);
      const resp = await membersessions(props.id);

      if (!resp) {
        return;
      }
      if (resp === "false") {
        setApiError(true)
        return;
      }
      const sessionData = await resp.json();
      console.log(sessionData, 'sessionData');
      setSessionData(sessionData)


      const transactions = await memberActiveTransactions(props.id)
      if (!transactions) {
        return;
      }
      if (transactions === "false") {
        setApiError(true)
        return;
      }
      const trans = await transactions.json();

      const transdata = trans
      console.log("transdata", transdata)

      transdata.sort((a, b) => {
        if (a.isplan === "1" && b.isplan !== "1") {
          return -1;
        } else if (a.isplan !== "1" && b.isplan === "1") {
          return 1;
        } else {
          return 0;
        }
      });
      setActTransactions(transdata);
      if (transdata.length > 0 && transdata[0].isplan === "1" && transdata[0].plan[0]?.sessioncheck && sessionData !== null) {
        const session = sessionData.length > 0 && sessionData.filter(item => transdata[0].plan[0].sessioncheck
          ? transdata[0]._id === item.transid : [])
        console.log(session);
        setSessionvalue(session.length > 0 ? session : null)
      }

      // setSelectedplan(transdata[0])
      if (props.data.planid) {
        const plansRes = await getPlanProfile(props.data.planid);
        if (!plansRes) {
          return;
        }
        if (plansRes === "false") {
          setApiError(true)
          return;
        }
        const record = await plansRes.json();
        console.log(record);


        if (record) {
          if (record.forcetrainer) {
            setTrainerForce(true);
          }
        }
      }
    }

    try {
      const loggedUser = JSON.parse(localStorage.getItem("loggedUserInfo"));
      const planResponse = await getPlans(loggedUser.gymid);

      if (!planResponse || planResponse === "false") {
        setApiError(true);
      } else {
        const plans = await planResponse.json();
        if (plans) {
          setPlans(plans);
        }
      }
    } catch (error) {
      console.error("Error fetching plans:", error);
      setApiError(true);
    }
    let gymid = JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymid;
    const activeSessionsReq = await getBookedsessionsbymid(gymid, { gymid: gymid, memberid: props.id, minutes: 30 });
    const activeSessionsRes = await activeSessionsReq.json();
    console.log("Chinna", activeSessionsRes);
    if (activeSessionsRes?.length > 0) {
      setActiveClasses(activeSessionsRes);
    }
  }

  function getToken() {
    try {
      const tokenString = localStorage.getItem("transactionId");
      return tokenString;
    } catch (e) {
      console.log("error :::::: " + e);
      return;
    }
  }
  const filteredData = actTransactions && actTransactions.length > 0 && actTransactions.filter(item => item.isplan === "1");
  console.log(filteredData);
  const plantrans = filteredData && filteredData.length > 0 ? filteredData[0] : actTransactions[0]
  const plansSessionSharedLimit = plantrans?.plan[0]?.sessionsharinglimit ? plantrans?.plan[0]?.sessionsharinglimit : 0

  const addMemToLineItems = async (newMember) => {

if (isGuestMode) {
  const guestsToAdd = Array.isArray(newMember) ? newMember : [newMember];

  const filteredNewGuests = guestsToAdd.filter(member => {
    const isDuplicate = guestPassMembers.some(p => p.memberId === member.memberId); 
    const isMainMember = member.memberId === props.id;                              
    return !isDuplicate && !isMainMember;
  });


  if (filteredNewGuests.length === 0) {
    setOpenAddMember(false);
    setIsGuestMode(false);
    return;
  }


  const allGuestsToValidate = [
    ...guestPassMembers.map(member => ({ id: member.memberId, email: member.email })),   
    ...filteredNewGuests.map(member => ({ id: member.memberId, email: member.email }))   
  ];

  const isValid = await gustPassValidityCheck(allGuestsToValidate);

  if (isValid) {
    setGuestPassMembers(prev => [...prev, ...filteredNewGuests]);
  }

  setOpenAddMember(false);
  setIsGuestMode(false);
  return;
}

    const hasAvailableSessions = sessionvalue && sessionvalue.length > 0 && sessionvalue[0].balsessions > 0;
    const sharingInfoLength = sessionvalue && sessionvalue.length > 0 ? sessionvalue[0]?.sharinginfo?.length : 0;

    console.log(plantrans, 'selectedUser.plan[0]');
    const sharingLimit = sessionvalue && sessionvalue.length > 0 && sessionvalue[0]?.sharinglimit ? sessionvalue[0].sharinglimit : plansSessionSharedLimit;
    let newMembersCount = Array.isArray(newMember) ? newMember.length : 1;

    const wouldExceedLimit = (sharingInfoLength + sharedSessionMember.length + newMembersCount) > sharingLimit;
    console.log(newMembersCount, sharedSessionMember.length, wouldExceedLimit, sharingLimit);
    const sharingLimitReached = sharingLimit !== undefined ? (sharingInfoLength !== undefined ? sharingInfoLength === sharingLimit : false) : false;
    console.log(sharingLimitReached, sharingInfoLength, sharingLimit, 'sharingLimitReached');

    if (!hasAvailableSessions) {
      alert("No available sessions to share!");
      return;
    }

    if (sharingLimitReached || sharingLimit < newMembersCount) {
      // Show error: Sharing limit already reached
      alert("You have already reached your sharing limit!");
      return;
    }

    if (wouldExceedLimit) {
      // Show error: Would exceed sharing limit
      const remainingSlots = sharingLimit - (sharingInfoLength + sharedSessionMember.length);
      alert(`You can only add ${remainingSlots} more member(s). You have exceeded your sharing limit!`);
      return;
    }

    // If all checks pass, add the members
    setSharedSessionMember(prevMembers => {
      const shouldAddMember = (member) => {
        const isDuplicate = prevMembers.some(prevMember => prevMember._id === member._id);
        const isPropsData = props.data && member._id === props.id;
        return !isDuplicate && !isPropsData;
      };

      if (Array.isArray(newMember)) {
        const filteredNewMembers = newMember.filter(shouldAddMember);
        return [...prevMembers, ...filteredNewMembers];
      } else {
        if (shouldAddMember(newMember)) {
          return [...prevMembers, newMember];
        }
        return prevMembers;
      }
    });

    setOpenAddMember(false);
  };

  console.log("sharedSessionMember", sharedSessionMember);



  const gustPassValidityCheck = async (guestsToValidate) => {
    if (!guestsToValidate || guestsToValidate.length === 0) {
      return false;
    }

    const gymid = JSON.parse(localStorage.getItem("loggedUserInfo")).gymid;
    const updates = {
      memberId: props?.id,
      selectedPlan: selectedplan?.itemid,
      selectedGuests: guestsToValidate,
      gymId: gymid,
      transid: selectedplan?._id
    };


    try {
      const data = await gustPassReferalCheck(updates);
      const response = await data.json();

      if (response.message) {
        setgustPassErrorMsg(response?.message);

        // If validation fails and there are invalid guests, filter them out
        if (response.invalidGuests && response.invalidGuests.length > 0) {
          const invalidIds = response.invalidGuests.map(id => id.toString());
          setGuestPassMembers(prev =>
            prev.filter(member => !invalidIds.includes(member.memberId?.toString()))
          );
        }

        return false;
      }

      setgustPassErrorMsg("");
      return true;
    } catch (error) {
      console.error("Error validating guest pass:", error);
      setgustPassErrorMsg("Error validating guest pass. Please try again.");
      return false;
    }
  };

  useEffect(() => {
    fetchMemberlatestCheckin()
  }, [])
  useEffect(() => {
    fetchData();

    const now = new Date();
    const currentHour = now.getHours();
    let fday1 = "AM";
    fday1 = currentHour >= 12 ? "PM" : "AM";
    setForm((prevForm) => ({
      ...prevForm,
      fday1: fday1,
    }));

  }, []);
  const [lastAttendance, setLastAttendance] = useState({})
  async function fetchMemberlatestCheckin() {
    if (localStorage.getItem("loggedUserInfo")) {
      const response = await getMemberlatestCheckin(props.id
      );
      if (!response) {
        return;
      }
      if (response === "false") {
        setApiError(true)
        return;
      }
      const attendanceData = await response.json();
      console.log(attendanceData, 'attendanceData');

      setLastAttendance(attendanceData?.attendance || {})
    }
  }



  const updateForcetrainer = async () => {
    const plansRes = await getPlanProfile(selectedplan.itemid);
    if (!plansRes) {
      return;
    }
    if (plansRes === "false") {
      setApiError(true)
      return;
    }
    const record = await plansRes.json();
    console.log(record);


    if (record) {
      if (record.forcetrainer) {
        setTrainerForce(true);
      }
    }
  }

  useEffect(() => {
    if (selectedplan !== null && selectedplan && selectedplan?.isplan == "1") {
      updateForcetrainer()
    }

  }, [selectedplan])
  useEffect(() => {
    let chflg = props.value === "Check-Out" ? "3" : (props.value === "Check-In" ? "2" : "1");
    if (TrainerForce && trainer === "" && chflg !== "3") {
      setErrorr({
        ...Errorr,
        trainer: "Trainer is required",
      });

    } else {
      setErrorr({
        ...Errorr,
        trainer: "",
      })
    }

  }, [TrainerForce, trainer]);

  // const filteredData = actTransactions && actTransactions.length > 0 && actTransactions.filter(item => item.isplan === "1");
  // console.log(filteredData);
  // const plantrans = filteredData && filteredData.length > 0 ? filteredData[0] : actTransactions[0]
  const submitHandler = (e) => {
    if (navigator.onLine) {
      console.log("online");
    } else {
      setIsButtonDisabled(false);
      setError2("No Internet Connection. Please check your internet connection and try again.");
      return;
    }
    if (!isButtonDisabled) {
      setIsButtonDisabled(true);
      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 30000);
      onSubmit(e);
    } else {
      console.log("button is clicked Just now. Please wait...");
    }
  }
  async function onSubmit(e) {
    e.preventDefault();
    try {
      // let complimanritylimit = process.env.REACT_APP_
      // const plantrans=actTransactions.filter()
      console.log(plantrans);
      let selectedtrans = selectedplan !== null ? selectedplan : plantrans;
      console.log(selectedtrans);
      let chflg = props.value === "Check-Out" ? "3" : (props.value === "Check-In" ? "2" : "1");
      setSelectedplan(selectedtrans)


      let browserinfo = browserName + "-" + browserVersion + ".0.0";
      let ip = localStorage.getItem("ipaddress");
      let Eventtype = "check-In/check-Outs(s)";
      let gymid = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "";
      let username1 = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).email : "";

      let staffname = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).name : "";
      let flag = `${props.data.fname} ${props.data.lname} is ${props.value === "Check-In" ? "Check-In Successful"
        : (props.value === "Check-Out" ? "Check-Out Successful"
          : "Log Time Successful")} by (${staffname})`;

      let updates = {};

      let ftimeh = Number(form.ftimeh);
      let ttimeh = Number(form.ttimeh);
      // console.log(form.ftimeh, ftimeh, ttimeh);

      if (form.fday1 === 'PM' && ftimeh < 12) {
        ftimeh = ftimeh === 12 ? ftimeh : ftimeh + 12

        setForm({
          ...form,
          ftimeh: ftimeh
        })
      } if (form.fday1 === 'AM') {
        ftimeh = ftimeh === 12 ? "00" : ftimeh
        setForm({
          ...form,
          ftimeh: ftimeh === 12 ? "00" : ftimeh
        })
      }
      if (form.fday2 === 'AM') {
        ttimeh = ttimeh === 12 ? "00" : ttimeh
      } if (form.fday2 === 'PM' && ttimeh < 12) {
        ttimeh = ttimeh === 12 ? ttimeh : ttimeh + 12
      }
      console.log("its Hour" + ftimeh);
      const date = `${getDateTime(form.date).date} ${ftimeh}:${form.ftimem}:00 GMT+0530 (India Standard Time)`;
      const tdate = `${getDateTime(form.date).date} ${ttimeh}:${form.ttimem}:00 GMT+0530 (India Standard Time)`;
      console.log("its date" + date);
      await trackButtonClick("logatime", "Member_Check-in", "staff", {});

      if (((props.value !== 'Check-Out') || (props.value === "Log Time"))) {
        console.log(selectedtrans);
        if (selectedtrans?.isplan) {
          await resumeSubmitFunction(selectedtrans, date)
        }
      }

      // Check if it's a shared session check-in
      const isSharedCheckin = sharedSessionMember && sharedSessionMember.length > 0;
      const includeMainMember = checkinOption === 'withYou';
      const selectedMemberid = sharedSessionMember?.length > 0 ? sharedSessionMember.map(member => ({ id: member._id })) : []
      const loggedUserInfo = JSON.parse(localStorage.getItem("loggedUserInfo"))?.gymname;
      const currentGymId = localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : ""


      const isGuestCheckin = guestPassMembers.length > 0;

      const selectedGuestIds = guestPassMembers.map(member => ({
        id:member.memberId
      }));
      // const selectedGuestIds = guestPassMembers.map(m => m.memberId || m._id);

      switch (chflg) {
        case "1":
          /*****
           * from time and to time both are set 
           *  then this case will execute and inserts both checkin time and checkout time
          */
          // if (DayValidation(date)) {
          updates = {
            checkFlag: "1",
            checktype: "Log Time",
            mid: props.id,
            _id: props.id,
            autocheckout: 0,
            // date: date,
            gymid: localStorage.getItem("loggedUserInfo") ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "",
          };

          // saverep = await checkMembers(updates, props.data._id);
          updates = {
            checkFlag: "0",
            checktype: "Log Time",
            mid: props.id,
            _id: props.id,
            date: date,
            fdate: date,
            tdate: !activeClass ? tdate : new Date(selectedtrans?.expirydate),
            gymid: props?.data?.isMultiGym ? props?.data?.bId : gymid,
            selectedplan: !activeClass ? selectedtrans : null,
            sessionvalue: sessionvalue,
            Complementary: cpCheck,
            scheduletransid: !activeClass ? null : selectedtrans?._id,
            // Add shared session data
            isSharedCheckin: isSharedCheckin,
            sharedMembers: isSharedCheckin ? selectedMemberid : [],
            includeMainMember: includeMainMember,
            partnerGymId: props?.data?.isMultiGym ? gymid : null,
            venuename: loggedUserInfo || "partnergym",
            homegymname: props?.bId?.businessName,

            guestChekin: isGuestCheckin,
            guestMembers: isGuestCheckin ? selectedGuestIds : [],
          };
          if (trainer !== "") {
            updates = { ...updates, trainer: trainer, trainerid: trainerid, };
          }
          if (sessionvalue && sessionvalue.length > 0 && cpCheck && sessionvalue[0].usedcomp >= 20) {
            setBasicDanger(true)
          } else {
            const res = await checkMembers(updates, props.id);
            const result = await res.json();
            if (result && (result.status || result.staus)) {
              logEvent({ Eventtype, username1, ip, flag, browserinfo, gymid }, gymid);
            }
            // window.location.href = "/checkin";
            props.onsave(updates, props.data);
          }
          break;
        case "2":
          /*********** Only checkin *************/
          const hours = Math.floor(auto);
          const minutes = Math.round((auto % 1) * 60);

          let totalHours = Number(ftimeh) + hours;
          let totalMinutes = Number(form.ftimem) + minutes;

          // If minutes exceed 60, adjust hours and minutes accordingly
          if (totalMinutes >= 60) {
            totalHours += Math.floor(totalMinutes / 60);
            totalMinutes %= 60;
          }

          // If hours exceed 24, adjust the value
          let value2 = totalHours > 24 ? (totalHours - 24) : totalHours;
          // console.log(value2, totalMinutes);

          form.autocheck = getDateTime(form.date).date + " " + value2 + ":" + (totalMinutes < 10 ? '0' : '') + totalMinutes + ":00 GMT+0530 (India Standard Time)";
          updates = {
            checkFlag: "1",
            mid: props.id,
            _id: props.id,
            date: date,
            autocheckout: !activeClass ? (auto !== "" ? form.autocheck : 0) : new Date(selectedtrans?.expirydate),
            gymid: props?.data?.isMultiGym ? props?.data?.bId : gymid,
            selectedplan: !activeClass ? selectedtrans : null,
            sessionvalue: sessionvalue,
            Complementary: cpCheck,
            scheduletransid: !activeClass ? null : selectedtrans?._id,
            // Add shared session data
            isSharedCheckin: isSharedCheckin,
            sharedMembers: isSharedCheckin ? selectedMemberid : [],
            includeMainMember: includeMainMember,
            partnerGymId: props?.data?.isMultiGym ? gymid : null,
            venuename: loggedUserInfo || "partnergym",
            homegymname: props?.bId?.businessName,
            guestChekin: isGuestCheckin,
            guestMembers: isGuestCheckin ? selectedGuestIds : [],
          };
          if (trainer !== "") {
            updates = { ...updates, trainer: trainer, trainerid: trainerid, };
          }

          if (sessionvalue && sessionvalue.length > 0 && cpCheck && sessionvalue[0].usedcomp >= 20) {
            setBasicDanger(true)
          } else {
            console.log(updates);

            const res = await checkMembers(updates, props.data.memberId || props.id);
            const result = await res.json();
            console.log(result);

            if (result && (result.status || result.staus)) {
              logEvent({ Eventtype, username1, ip, flag, browserinfo, gymid }, gymid);
            }

            props.onsave(updates, props.data);
          }

          break;
        case "3":
          /***** only checkout*****/
          updates = {
            checkFlag: "0",
            mid: props.id,
            _id: props.id,
            date: date,
            gymid: gymid,
            isSharedCheckin: false,
            sharedMembers: [],
            includeMainMember: true,
            guestChekin: guestPassMembers.length > 0,
            guestMembers: guestPassMembers.map(m => ({ id: m.memberId })),
          };
          const res = await checkMembers(updates, props.id);
          const result = await res.json();
          console.log(result);

          if (result && (result.status || result.staus)) {
            logEvent({ Eventtype, username1, ip, flag, browserinfo, gymid }, gymid);
          }
          props.onsave(updates, props.data);
          break;
        default:
          // Default case if none of the above cases match
          console.error("Invalid checkFlag value:", chflg);
          setIsButtonDisabled(false);
          break;
      }
      // console.log(updates);
    } catch (error) {
      setIsButtonDisabled(false);
      console.error("Error in check-In data:", error);
    }
  }


  let pauseData = [];
  if (selectedplan && selectedplan.pause && selectedplan.pause.length > 0) {
    pauseData = [selectedplan.pause.sort((a, b) => b.sno - a.sno)[0]];
  } else if (actTransactions && actTransactions.length > 0 && actTransactions[0].pause && actTransactions[0].pause.length > 0) {
    pauseData = [actTransactions[0].pause.sort((a, b) => b.sno - a.sno)[0]];
  }

  let id = JSON.parse(localStorage.getItem("loggedUserInfo")) ? JSON.parse(localStorage.getItem("loggedUserInfo")).gymid : "";
  let ip = localStorage.getItem("ipaddress");
  let browserinfo = browserName + "-" + browserVersion + ".0.0";
  let Eventtype = "Membership";
  let gymid = id;
  let username1 = JSON.parse(localStorage.getItem("loggedUserInfo")) ? JSON.parse(localStorage.getItem("loggedUserInfo")).email : "";

  async function resumeSubmitFunction(selectedtrans) {
    if (pauseData.length > 0 && pauseData[0].resume === true) {
      let transaction = selectedtrans;
      let pausedDate = new Date(pauseData[0].fromtime);
      let currentTime = new Date();
      currentTime.setHours(pausedDate.getHours());
      currentTime.setMinutes(pausedDate.getMinutes());
      currentTime.setSeconds(pausedDate.getSeconds());
      currentTime.setMilliseconds(pausedDate.getMilliseconds());

      let OldPausedDate = new Date(pauseData[0].totime);
      const dayDifference = (OldPausedDate - currentTime) / (1000 * 60 * 60 * 24);

      let enddate = new Date(transaction.expirydate);
      enddate.setDate(enddate.getDate() - Math.ceil(dayDifference));

      let updates = {
        date: pauseData[0].date,
        fromtime: pauseData[0].fromtime,
        totime: currentTime,
        resume: false,
        sno: pauseData[0].sno,
        enddate: enddate,
        transaction: transaction,
        gymid: selectedtrans.gymid,
      };
      await resumeMemberShip(selectedtrans.gymid, updates);
      let flag = `Plan Resume Successfull (${props.data.fname} ${props.data.lname})`;
      await logEvent({ Eventtype, username1, ip, flag, browserinfo, gymid }, gymid);
    }
  }


  function getDateTime(tdbtime) {
    var now = new Date(tdbtime);
    var year = now.getFullYear();
    var month = now.getMonth() + 1;
    var day = now.getDate();
    var hour = now.getHours();
    var minute = now.getMinutes();

    month = month.toString().padStart(2, "0");
    day = day.toString().padStart(2, "0");
    hour = hour.toString().padStart(2, "0");
    minute = minute.toString().padStart(2, "0");

    var dateTime = {
      date: year + "-" + month + "-" + day,
      time: hour + ":" + minute,
    };
    // console.log(dateTime);
    return dateTime;
  }

  const handleTimeChange = (selectedTime) => {
    const timeFormatRegex = /^(0?[1-9]|1[0-2]):[0-5][0-9]\s(AM|PM)$/;
    if (typeof selectedTime === 'string' && timeFormatRegex.test(selectedTime)) {
      const [time, ampm] = selectedTime.split(" ");
      let [hours, minutes] = time.split(":");
      hours = parseInt(hours);
      minutes = parseInt(minutes);

      // Convert selected time to 24-hour format for comparison
      if (ampm === "PM" && hours !== 12) hours += 12;
      if (ampm === "AM" && hours === 12) hours = 0;

      // Construct a Date object for selected time
      const selectedDateTime = new Date();
      selectedDateTime.setHours(hours, minutes, 0, 0);

      // Compare with auto checkout (if available)
      if (props.data.attendance && props.data.attendance[0] && !props.data.attendance[0].outtime && props.data.attendance[0].autocheckout && activeClass) {
        const endDate = new Date(props.data.attendance[0].autocheckout);

        if (selectedDateTime > endDate) {
          setErrorr({
            ...Errorr,
            fromTime: "Selected time cannot be later than the class time.",
          });
          return; // stop further execution
        }
      }
      if (selectedplan?.expirydate) {
        const endDate = new Date(selectedplan?.expirydate);

        if (selectedDateTime > endDate) {
          setErrorr({
            ...Errorr,
            fromTime: "Selected time cannot be later than the class time.",
          });
          return;
        }
      }
      // If valid
      setErrorr({
        ...Errorr,
        fromTime: "",
      });

      const updatedForm = {
        ...form,
        ftimeh: hours % 12 === 0 ? 12 : hours % 12, // keep in 12-hour format
        ftimem: minutes.toString().padStart(2, "0"),
        fday1: ampm,
      };

      setForm(updatedForm);
    } else {
      setErrorr({
        ...Errorr,
        fromTime: "Please select a valid time.",
      });
    }
  };
  console.log(selectedplan)
  const handleTimeChange1 = (selectedTime) => {
    const timeFormatRegex = /^(0?[1-9]|1[0-2]):[0-5][0-9]\s(AM|PM)$/;

    if (typeof selectedTime === 'string' && timeFormatRegex.test(selectedTime)) {
      setErrorr({
        ...Errorr,
        toTime: "",
      });
      const [time, ampm] = selectedTime.split(" ");
      const [hours, minutes] = time.split(":");
      const updatedForm = {
        ...form,
        ttimeh: hours,
        ttimem: minutes,
        fday2: ampm,
      };


      setForm(updatedForm);
    } else {
      setErrorr({
        ...Errorr,
        toTime: "Please select a valid time.",
      });
    }
  };

  function onChangeTrainerFunction(event) {
    const selectedIndex = event.target.selectedIndex;
    const selectedUser = userdata[selectedIndex - 1];
    if (selectedUser) {
      setTrainer(selectedUser.firstname + ' ' + selectedUser.lastname);
      settrainerid(selectedUser._id);
    } else {
      setTrainer('');
      settrainerid();
    }
  }


  const HandlerDateChange = (selectedTime) => {
    if (selectedTime instanceof Date && !isNaN(selectedTime)) {
      updateForm({ date: selectedTime });
    } else {
      updateForm({ date: form.date });
    }
  };

  const CalendarInput = ({ value, onClick }) => (
    <input
      type="text"
      value={value}
      readOnly={true}
      className="w-100 form-control"
      onClick={onClick}
    />
  );
  useEffect(() => {
    if (actTransactions.length > 0) {
      const selectedUser = actTransactions[0];
      setSelectedplan(selectedUser);
      setActiveClass(false);
    } else {
      if (activeClasses.length > 0) {
        const selectedUser = activeClasses[0];
        setSelectedplan(selectedUser);
        updateForm({ date: new Date(selectedUser?.startdate), });
        setActiveClass(true);
        setTrainer(selectedUser?.staff?.firstname + ' ' + selectedUser?.staff?.lastname);
        settrainerid(selectedUser?.staff?._id);
      }
    }
    if (props.value === "Check-Out") {
      let value = lastAttendance;
      console.log(value)
      if (value?.scheduletransid) {
        if (activeClasses)
          setActiveClass(true);
      }
    }
  }, [actTransactions, activeClasses]);

  const HandlerplanChange = (e) => {
    let value = e.target.value;
    const selectedIndex = e.target.selectedIndex;
    const selectedUser = actTransactions[selectedIndex];
    if (value == "membership") {
      if (selectedUser.isplan === "1" && selectedUser.plan[0].sessioncheck) {
        const session = sessionData.length > 0 && sessionData.filter(item => selectedUser.plan[0]._id === item.planid && selectedUser._id === item.transid)
        setSessionvalue(session.length > 0 ? session.length > 1 ? null : session : null)
      } else {
        setSessionvalue(null)
      }
      setActiveClass(false);
      setSelectedplan(selectedUser);

      if (props.data?.isMultiGym) {
        const selectedPlanId = selectedUser.itemid?.toString();
        const allowedPlans = props.data?.allowedPlans || [];
        if (selectedPlanId && allowedPlans.length > 0 && !allowedPlans.includes(selectedPlanId)) {
          setMultiGymPlanError("This plan does not have multi-gym check-in access.");
        } else {
          setMultiGymPlanError("");
        }
      }
    } else {
      setSessionvalue(null);
      setActiveClass(true);
      setMultiGymPlanError("");
      const selectedclass = activeClasses.find(obj => obj._id == value);
      let staffDetails = selectedclass?.staff;

      setSelectedplan(selectedclass);
      updateForm({ date: new Date(selectedclass?.startdate) });
      setTrainer(staffDetails.firstname + ' ' + staffDetails.lastname);
      settrainerid(staffDetails._id);
    }
  }

  let PauseLastDate = (pauseData && pauseData.length > 0 && pauseData[0].totime) ? new Date(pauseData[0].totime) : new Date();
  let PauseLastDateString = `${PauseLastDate.getDate().toString().padStart(2, '0')}-${(PauseLastDate.getMonth() + 1).toString().padStart(2, '0')}-${PauseLastDate.getFullYear()}`

  const handleReload = () => {
    window.location.reload();
  }

  console.log(props);

  const isFormValid = () => {
    return Object.values(Errorr).every((value) => value === "") && multiGymPlanError === "";
  };
  console.log(Errorr);

  const onSubmitUser = () => {
    setSubmitFlag(true);
    setTimeout(() => {
      setSubmitFlag(false);
    }, 100);
  };


  const handleGust = () => {
    setOpenAddMember(true);
    setIsGuestMode(true);
  };

  return (
    <>
      {apiError ? <PageError handleReload={handleReload} /> :
        <div className="w-100 d-flex flex-column h-100">
          <div className=" overflow-auto" style={{ maxHeight: '400px' }}>
            <div className=" mb-3" >
              <div className="d-flex me-3">
                <div >
                  <MDBTooltip tag='div' wrapperProps={{ className: "view-name m-0 checkIn-Head" }}
                    title={props.data.fname
                      ? props.data.fname + " " + props.data.lname
                      : props.data.firstname + " " + props.data.lastname} >
                    {props.data.fname
                      ? props.data.fname + " " + props.data.lname
                      : props.data.firstname + " " + props.data.lastname} {checkinOption == "withYou" && sharedSessionMember.length > 0 && <MDBIcon fas icon="check-circle" className="ms-2" color="success" />}
                  </MDBTooltip>
                  <p className="text-dark m-0">
                    {props.data.sex ? props.data.sex : ""}{((props.data.age || props.data.number) && props.data.sex) ? ', ' : ''}
                    {props.data.age ? props.data.age + "y" : ""}{(!props.data.number || !props.data.age) ? '' : ', '}
                    {/* {props.data.weight ? props.data.weight + "kgs" : ""}{(!props.data.number) ? ' ' : ', '} */}
                    {props.data.number ? props.data.number + " " : ""}
                  </p>
                </div>
                <div>
                </div>

              </div>

              {sessionvalue && sessionvalue.length > 0 && sessionvalue[0].balsessions <= 0 ?
                <span >
                  Plan Expired: <span className={"text-danger mt-3"}>Out of Session(s)</span></span>
                : <>
                  {pauseData.length > 0 && pauseData[0].resume ?
                    <div className="pb-3">
                      <span className={"text-danger mt-3"}>
                        {`Plan Paused Until ${PauseLastDateString}`}</span>
                    </div> :
                    <div className="">
                      <span className={props.expires && (props.expires.includes('Expired')) ? "text-danger mt-3" : "text-dark mt-3"}>
                        {props.expires.includes('No Plan') ? "" : "Plan"} {props.expires}</span>
                    </div>}</>}
            </div>

            {props.value !== 'Check-Out' && (actTransactions && actTransactions.length > 0 || activeClasses?.length > 0) && <div className="d-flex align-items-baseline ">
              <span className="w-30">{(actTransactions && actTransactions.length > 0) ?
                (`Plan/Addon${activeClasses?.length > 0 ? "/" : ""}`) : ""}{activeClasses?.length > 0 ? "Class" : ""}: </span>
              <div className="w-50">
                <div className="d-flex justify-content-end flex-column">

                  <select
                    className="w-100 form-control form-select"
                    onChange={(e) => HandlerplanChange(e)}
                  >
                    {actTransactions && actTransactions.length > 0 && actTransactions.map((data, index) => {
                      let label = "";
                      // CASE 1: If plan exists
                      if (data.plan && data.plan.length > 0) {
                        const planObj = data.plan[0];

                        // variation plan (has baseplan)
                        if (planObj.baseplan) {
                          const baseName = BasePlanName(plans, planObj.baseplan);
                          label = baseName ? `${baseName} - ${planObj.name}` : planObj.name;
                        } else {
                          label = planObj.name;
                        }
                        // check pause
                        if (data.pause && data.pause.length > 0) {
                          label += data.pause.every(item => item.resume === false)
                            ? " (Plan-paused)"
                            : " (Plan)";
                        } else {
                          label += " (Plan)";
                        }

                        // CASE 2: If addon exists
                      } else if (data.addons && data.addons.length > 0) {
                        label = data.addons[0].name;
                        if (data.pause && data.pause.length > 0) {
                          label += data.pause.every(item => item.resume === false)
                            ? " (Addon-paused)"
                            : " (Addon)";
                        } else {
                          label += " (Addon)";
                        }
                      }

                      return (
                        <option key={index} value={"membership"}>
                          {label}
                        </option>
                      );
                    })}
                    {activeClasses?.length > 0 && activeClasses.map((data, index) => {
                      let label = data.class.name + " (Class)";
                      return (
                        <option key={index} value={data._id}>
                          {label}
                        </option>
                      );
                    })}
                  </select>
                  {sessionvalue && sessionvalue.length > 0 && <div className=""><span className="text-dark">Session(s) Remaining: {sessionvalue[0].balsessions === 0 ? <span className="text-danger">0</span> : <span>{sessionvalue[0].balsessions}</span>}</span></div>}
                  {multiGymPlanError && <div className=""><label className="text-danger check-errorTxt">{multiGymPlanError}</label></div>}

                </div>

              </div>
              {sessionvalue && sessionvalue.length > 0 && (sessionvalue[0]?.sharinginfo?.length > 0 ? sessionvalue[0]?.sharinginfo?.length < (sessionvalue[0]?.sharinglimit || plansSessionSharedLimit) : true) &&
                <button type="submit" className="ms-1 btn btn-primary d-flex align-self-start" data-mdb-dismiss="modal" onClick={() => setOpenAddMember(!openAddMember)}>  Sessions</button>
              }

               {selectedplan?.isplan === "1" && (props.guestpass === undefined || (props.guestpass?.length > 0 && props.guestpass[0].balguestpass > 0)) && (
                <div className="flex-grow-1">
                  <button
                    type="button"
                    className="btn btn-primary ms-1 d-flex align-items-center"
                    onClick={handleGust}
                  >
                    <MDBIcon fas icon="ticket-alt" className="me-1" /> Pass
                  </button>
                </div>
              )}

            </div>

            }


            {sharedSessionMember && sharedSessionMember.length > 0 && <div className="d-flex align-items-baseline ">
              <span className="w-20">Selected Members: </span>

              <div className="w-50">
                {sharedSessionMember && sharedSessionMember.length > 0 && (
                  <div className="mb-3">
                    {/* <h6>Selected Members:</h6> */}
                    {sharedSessionMember.map((member, index) => (
                      <div key={member._id || index} className="d-flex align-items-center justify-content-between p-2 mb-2">
                        <span> <MDBIcon fas icon="check-circle" className="me-1" color="success" /> {member.fname} {member.lname}</span>
                        {/* <MDBBtn className='ms-2' onClick={() => {
                          setSharedSessionMember(prev => prev.filter((_, i) => i !== index));
                        }} color='danger' outline floating style={{ width: '35px', height: '35px' }}> */}
                        <MDBIcon color="danger" icon="times" onClick={() => {
                          setSharedSessionMember(prev => prev.filter((_, i) => i !== index));
                        }} />
                        {/* </MDBBtn> */}

                      </div>
                    ))}
                  </div>
                )}
              </div>

            </div>}

            {sharedSessionMember && sharedSessionMember.length > 0 && (
              <div className="d-flex align-items-baseline mb-3">
                <span className="w-20">Check-in Option: </span>
                <div className="w-70">
                  <MDBRadio
                    name='checkinOption'
                    id='withYou'
                    value='withYou'
                    label='Check in with members, including you.'
                    checked={checkinOption === 'withYou'}
                    onChange={(e) => setCheckinOption(e.target.value)}
                    className="mb-2"
                  />
                  <MDBRadio
                    name='checkinOption'
                    id='othersOnly'
                    value='othersOnly'
                    label='Members-only check-in.'
                    checked={checkinOption === 'othersOnly'}
                    onChange={(e) => setCheckinOption(e.target.value)}
                  />
                </div>
              </div>
            )}
            {guestPassMembers && guestPassMembers.length > 0 && (
              <div className="d-flex align-items-baseline mt-2">
                <span className="w-20">Guest Members: </span>

                <div className="w-50">
                  {guestPassMembers.map((member, index) => (
                    <div key={member._id || index}
                      className="d-flex align-items-center justify-content-between p-2 mb-2">

                      <span>
                        <MDBIcon fas icon="check-circle" className="me-1" color="success" />
                        {member.fname} {member.lname}
                      </span>

                      <MDBIcon
                        color="danger"
                        icon="times"
                        onClick={() =>
                          setGuestPassMembers(prev =>
                            prev.filter((_, i) => i !== index)
                          )
                        }
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}

            {guestPassMembers.length > 0 && (
              <div className="d-flex align-items-baseline mb-3">
                <span className="w-20">Check-in Option: </span>
                <div className="w-70">
                  <MDBRadio
                    name='guestCheckinOption'
                    id='guestWithYou'
                    value='withYou'
                    label='Check in with guests, including you.'
                    checked={checkinOption === 'withYou'}
                    onChange={(e) => setCheckinOption(e.target.value)}
                    className="mb-2"
                  />
                  <MDBRadio
                    name='guestCheckinOption'
                    id='guestOthersOnly'
                    value='othersOnly'
                    label='Guests-only check-in.'
                    checked={checkinOption === 'othersOnly'}
                    onChange={(e) => setCheckinOption(e.target.value)}
                  />
                </div>
              </div>
            )}



            {!activeClass && <div className="d-flex align-items-baseline mt-3">
              <span className="w-20">Select Date: </span>
              <div className="w-50 d-flex justify-content-end flex-column">
                <DatePicker
                  selected={form.date}
                  dateFormat="MM-dd-yyyy"
                  onChange={(date) => HandlerDateChange(date)}
                  isClearable={false}
                  customInput={<CalendarInput />}
                  maxDate={new Date()}
                />
              </div>
            </div>}

            <div className="d-flex align-items-baseline mt-3">
              <span className="w-20">Trainer: </span>
              <div className="w-50">
                <div className="">
                  {!activeClass && props.value !== 'Check-Out' ?
                    <select
                      className="w-100 form-control form-select"
                      onChange={(e) => onChangeTrainerFunction(e,)}
                    >
                      <option value=''>Select None</option>
                      {userdata && userdata.map((data, index) => (
                        <option key={index} value={data}>
                          {(data.firstname !== "" || data.lastname !== "") ? data.firstname + ' ' + data.lastname : data.email}
                        </option>
                      ))}
                    </select>
                    :
                    <label className="me-3">
                      {lastAttendance && lastAttendance?.trainer ? lastAttendance.trainer || trainer : 'None Selected'}
                    </label>
                  }
                </div>
                {/* {Errorr === 6 ? <label className="text-danger check-errorTxt">Please select a trainer.</label> : ""}
               */}
                {Errorr.trainer !== "" ? <label className="text-danger check-errorTxt"> {Errorr.trainer}</label> : ""}
              </div>
            </div>

            {(props.value === "Check-In" || props.value === "Check-Out") &&
              <div>
                <div className="d-flex align-items-baseline mt-3">
                  <span className="w-20">{props.value}: </span>
                  <div className="w-70  d-flex flex-column">
                    <div className="d-flex align-items-center">
                      <div className="w-50  d-flex"><MDBTimepicker inline className="h-auto" defaultValue={`${form.ftimeh}:${form.ftimem} ${form.fday1}`}
                        onChange={(time) => handleTimeChange(time)}
                      // justInput
                      // maxTime="6:35 PM"
                      />
                      </div>
                      <div className="ms-2">(Ex:- 09:30 AM)</div>
                    </div>
                    {/* {Errorr == 2 ? <label className="text-danger check-errorTxt"> The selected time should be within the business working hours.</label> : ""} */}

                    {Errorr.fromTime !== "" ? <label className="text-danger check-errorTxt"> {Errorr.fromTime}</label> : ""}
                  </div>
                </div>
                {props.value !== '' &&
                  <div className="d-flex align-items-center mt-2 autoChehckout">
                    {!activeClass && props.value === "Check-In" && <MDBCheckbox name='inlineCheck' className="p-0" id='inlineCheckbox1' label='Auto Check-Out' inline onClick={() => setCheck((obj) => !obj)} />}
                    {(activeClass || props.value === "Check-Out") && lastAttendance && lastAttendance?.autocheckout !== 0 && <label>Auto Check-Out:</label>}
                    {/* {props.value == "Check-Out" && props.data.checkinInfo[0] && props.data.checkinInfo[0].autocheckout != 0 && ":"} */}
                    {(activeClass || props.value === "Check-Out") && lastAttendance && lastAttendance?.autocheckout !== 0 &&
                      <div className="w-50  d-flex justify-content-end"><label>{
                        new Date(props.value === "Check-Out" ? lastAttendance.autocheckout : selectedplan?.expirydate)
                          .toLocaleTimeString("en-IN", {
                            timeZone: "Asia/Kolkata",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                          })
                      }</label></div>}
                    {!activeClass && Check &&
                      <div className="w-55 pe-3  d-flex justify-content-end" >
                        <MDBInputGroup className='mb-3' textAfter='Hours' style={{ marginLeft: "9px" }}>
                          <input className='form-control' type='number' placeholder="Ex:1, 1.5"
                            onChange={(e) => { if (e.target.value >= 12) { setAuto(12) } else { setAuto(e.target.value) } }}
                            value={auto}
                            autoFocus
                          />
                        </MDBInputGroup>
                      </div>}
                  </div>}
              </div>}
            {(!sharedSessionMember.length > 0 && props.value !== "Check-Out" && sessionvalue !== null) && <MDBCheckbox name='inlineCheck2' className="p-0" id='inlineCheckbox2' checked={cpCheck} label='Complementary' inline onChange={() => setCpCheck(!cpCheck)} />}

            {(props.value === "Log Time") &&
              <div className="d-flex align-items-baseline mt-3">
                <span className="w-30"> {!props.value || props.value === "Log Time" ? "Log Time" : "Log Time"}</span>
                <div className="w-70 d-flex justify-content-end flex-column textTimeLabel">
                  <MDBInputGroup className='mb-3 logtime-text align-items-center' noBorder textBefore='From'>
                    <MDBTimepicker inline defaultValue={`${form.ftimeh}:${form.ftimem} ${form.fday1}`}
                      onChange={(time) => handleTimeChange(time)} className="w-150px"
                    />
                    <div className="ms-2 small-text">(Ex : 09:30 AM)</div>
                  </MDBInputGroup>
                  {/* {Errorr == 2 ? <label className="text-danger check-errorTxt">The selected time should be within the Gym hours.</label> : ""} */}
                  {/* {Errorr == 5 ? <label className="text-danger check-errorTxt valitTimeCheckin"> Please select a valid time.</label> : ""} */}
                  {Errorr.fromTime !== "" ? <label className="text-danger check-errorTxt valitTimeCheckin"> {Errorr.fromTime}</label> : ""}
                  <MDBInputGroup className='mb-3 ps-0 d-flex align-items-center' noBorder textBefore='To'>
                    {!activeClass ? <>
                      <MDBTimepicker inline defaultValue={`${form.ttimeh}:${form.ttimem} ${form.fday2}`}
                        onChange={(time) => handleTimeChange1(time)} className="w-150px"
                      />
                      <div className="ms-2 small-text">(Ex : 09:30 AM)</div>
                    </> :
                      <div className="ms-2">{
                        new Date(selectedplan?.expirydate)
                          .toLocaleTimeString("en-IN", {
                            timeZone: "Asia/Kolkata",
                            hour: "2-digit",
                            minute: "2-digit",
                            second: "2-digit",
                          })
                      }
                      </div>
                    }
                  </MDBInputGroup>
                  {Errorr.toTime !== "" ? <label className="text-danger check-errorTxt valitTimeCheckin"> {Errorr.toTime}</label> : ""}
                </div>
              </div>
            }
          </div>

          <div className="modal-footer justify-content-start">
            <button
              type="submit"
              className="btn btn-primary"
              data-mdb-dismiss="modal"
              onClick={(e) => submitHandler(e)}
              // disabled={Errorr == 0 ? false : true}
              disabled={!isFormValid()}
            >
              {props.value ? props.value : "Log Time"}
            </button>
            &nbsp;
            <button
              to="#"
              onClick={() => retrunFromThis()}
              className="btn btn-secondary"
              data-mdb-dismiss="modal"
            >
              Cancel
            </button>
          </div>

          <MDBAlert
            color='danger'
            autohide
            position='top-right'
            delay={2000}
            appendToBody
            open={basicDanger}
            onClose={() => setBasicDanger(false)}
          >
            You have exceeded the allowed maximum entry of the Complimentary
          </MDBAlert>

          <MDBAlert
            color='danger'
            autohide
            position='top-right'
            delay={5000}
            appendToBody
            open={Error2 != ""}
            onClose={() => setError2("")}
          >
            {Error2}
          </MDBAlert>
        </div>}

      {/* 
      {openAddMember && (
        <>
          <MDBModal open={openAddMember} onClose={() => setOpenAddMember(false)} tabIndex='-1'>
            <MDBModalDialog size="lg">
              <MDBModalContent>
                <MDBModalHeader>
                  <MDBModalTitle>Add Member(s)</MDBModalTitle>
                  <MDBBtn className='btn-close' color='none' onClick={() => {
                    setOpenAddMember(false);
                  }}></MDBBtn>
                </MDBModalHeader>
                <MDBModalBody>
                  <AddUsers
                    id={getToken()}
                    index={curIndex}
                    onsubmit={onSubmitUser}
                    submit={submitFlag}
                    onAdd={addMemToLineItems}
                  />
                </MDBModalBody>
              </MDBModalContent>
            </MDBModalDialog>
          </MDBModal>

        </>
      )} */}



      {openAddMember && (
<MDBModal open={openAddMember} onClose={() => setOpenAddMember(false)} tabIndex='-1' appendToBody>
            <MDBModalDialog size="lg">
            <MDBModalContent>
              <MDBModalHeader>
                <MDBModalTitle>
                  {isGuestMode ? (
                    <>
                      <MDBIcon fas icon="user-friends" className="me-2" />
                      Add Guest Pass Members
                    </>
                  ) : (
                    "Add Member(s)"
                  )}
                </MDBModalTitle>
                <MDBBtn className='btn-close' color='none' onClick={() => {
                  setOpenAddMember(false);
                  setIsGuestMode(false);
                }}></MDBBtn>
              </MDBModalHeader>
              <MDBModalBody>
                {isGuestMode ? (
                  // Show Guest Pass specific component
                  <GuestPassMembers
                    props={props}
                    onAdd={addMemToLineItems}
                    alreadyadded={guestPassMembers}
                  />
                ) : (
                  // Regular AddUsers component for session sharing
                  <AddUsers
                    id={getToken()}
                    index={curIndex}
                    onsubmit={onSubmitUser}
                    submit={submitFlag}
                    onAdd={addMemToLineItems}
                    isGuestMode={false}
                  />
                )}
              </MDBModalBody>
            </MDBModalContent>
          </MDBModalDialog>
        </MDBModal>
      )}

      <MDBAlert
        color='danger'
        autohide
        position='top-center'
        delay={8000}
        appendToBody
        open={gustPassErrorMsg != ""}
        onClose={() => setgustPassErrorMsg("")}
      >
        {gustPassErrorMsg}
      </MDBAlert>
    </>
  );
}